import script from "./user.vue?vue&type=script&setup=true&lang=js"
export * from "./user.vue?vue&type=script&setup=true&lang=js"

import "./user.vue?vue&type=style&index=0&id=25c59af8&lang=less&scoped=true"

import exportComponent from "/Users/timetravel/code/energy-storage-intelligence/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25c59af8"]])

export default __exports__